// Section 17: Manual. The engine proposes the priority result and hands it to the player
// unchanged (the shortage dialog is where the player edits it).
import { applyPins, flattenRanked, priorityFill } from '../../core/allocation';
import { defineRationPolicy } from '../../core/registry';
import type { Config } from '../../config';

export function manual(_config: Config) {
  return defineRationPolicy({
    id: 'manual',
    label: 'Manual',
    section: 'S17',
    allocate(_ctx, input) {
      const order = flattenRanked(input.ranked);
      const fill = applyPins(order, input.demand, input.available, input.pinned);
      for (const id of order) if (input.pinned[id] === undefined) fill.shares[id] = 0;
      priorityFill(
        input.ranked.map((g) => g.filter((id) => input.pinned[id] === undefined)),
        input.demand,
        fill,
      );
      return { shares: fill.shares, order };
    },
  });
}
